export default __webpack_public_path__ + "static/media/aboutCat2L.aaa1eb29.webp";